import React, { Component, PropTypes } from 'react';
import { StoreOverviewActions } from 'actions';
import FullScreenDialog from 'components/FullScreenDialog';
import ItemDetails from './ItemDetails';
import CountdownTimer from 'components/CountdownTimer';
import PaymentMethodChooser from 'components/Store/PaymentMethodChooser';
import KlarnaOnlineForm from 'containers/Store/KlarnaOnlineForm';
import KlarnaCheckoutForm from 'containers/Store/KlarnaCheckoutForm';
import StripeCheckoutForm from 'containers/Store/StripeCheckoutForm';
import AlertDialog from 'components/AlertDialog';
import Constants from 'Constants';
// import StripeCheckoutForm from 'components/Payment/StripeCheckoutForm';

const css = oxygenCss({
  message: {
    textAlign: 'center'
  }
});

class PurchaseDialog extends Component {
  static propTypes = {
    cart: PropTypes.array,
    open: PropTypes.bool,
    method: PropTypes.string,
    paymentCompleted: PropTypes.bool,
    onRequestClose: PropTypes.func,
    onComplete: PropTypes.func,
    activeDiscountCount: PropTypes.number
  };

  state = {
    alert: false
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  setMethod = method => {
    StoreOverviewActions.setPaymentMethod(method);
  };

  handleRequestClose = event => {
    const { onRequestClose } = this.props;

    if (onRequestClose) {
      onRequestClose();
    } else {
      StoreOverviewActions.reset();
    }
  };

  handleComplete = () => {
    const { isGift, onComplete } = this.props;
    if (onComplete) {
      onComplete();
    } else {
      StoreOverviewActions.reset();
      if (!isGift) {
        this.props.router.push('/dashboard');
      } else {
        this.setState({ alert: true });
      }
    }
  };

  componentWillReceiveProps(nextProps) {
    const { paymentCompleted, isGift } = this.props;
    if (isGift && !paymentCompleted && nextProps.paymentCompleted) {
      this.setState({ alert: true });
    }
  }

  render() {
    const {
      cart,
      isGift,
      open,
      method,
      activeDiscountCount,
      allowedPaymentProviders,
      paymentCompleted
    } = this.props;
    const { getIntlMessage } = this.context;
    const { alert } = this.state;
    const [item] = cart;
    const hasKlarnaCheckout =
      (allowedPaymentProviders || []).findIndex(
        provider => provider === Constants.paymentProviders.KLARNACHECKOUT
      ) > -1;
    if (paymentCompleted && !isGift) {
      return (
        <FullScreenDialog padded open toolbar={false}>
          <div className={css.message}>
            {getIntlMessage('store.purchaseSuccess')}
            <br />
            <CountdownTimer
              seconds={2}
              color="#777"
              alpha={0.3}
              size={128}
              onComplete={this.handleComplete}
            />
          </div>
        </FullScreenDialog>
      );
    } else if (paymentCompleted && isGift) {
      return (
        <AlertDialog
          onRequestClose={() => this.setState({ alert: false })}
          title={getIntlMessage('gift.purchaseComplete')}
          open={alert}
        >
          {getIntlMessage('gift.nextStep')}
        </AlertDialog>
      );
    }
    if (hasKlarnaCheckout) {
      return (
        <KlarnaCheckoutForm open onRequestClose={this.handleRequestClose} />
      );
    } else if (method === 'invoice' || method === 'account') {
      return <KlarnaOnlineForm open onRequestClose={this.handleRequestClose} />;
    } else if (method === 'creditcard') {
      return (
        <StripeCheckoutForm open onRequestClose={this.handleRequestClose} />
      );
    }
    return (
      <FullScreenDialog open={open} onRequestClose={this.handleRequestClose}>
        <ItemDetails activeDiscountCount={activeDiscountCount} {...item} />
        <PaymentMethodChooser onSetMethod={this.setMethod} />
      </FullScreenDialog>
    );
  }
}

export default PurchaseDialog;



// WEBPACK FOOTER //
// ./src/js/components/Store/PurchaseDialog.js